import * as React from 'react';
import { BaSeHeading5, BaSeParagraph } from '@base/react';
import { NotFoundServiceContent } from '../certificados-cliente-styled';
import { BaSeTheme } from '@base/react';
import { ReactComponent as NotFoundItems } from '../../../assets/services-not-found.svg';

export const NotFound = () => {
  const { cinzaSebrae30 } = BaSeTheme.colors.institucionais;

  return (
    <NotFoundServiceContent>
      <NotFoundItems />
      <BaSeHeading5 isBold color={cinzaSebrae30}>
        Nenhum registro encontrado.
      </BaSeHeading5>
      <BaSeParagraph color={cinzaSebrae30}>
        Realize a busca pelo CPF, Código produto ou Nome do produto
      </BaSeParagraph>
    </NotFoundServiceContent>
  );
};
